import { Path, Svg, Text, View } from '@react-pdf/renderer';
// eslint-disable-next-line no-restricted-imports
import { tv } from 'tailwind-variants';

import { Block } from '@eluve/llm-outputs';

import { tw } from '../pdf-tw';
import { commonStyles } from '../styles';
import { PdfAmendment } from '../types';

import { TextAmendments } from './TextAmendments';

const styles = tv({
  slots: {
    checkboxSvg: 'mr-2',
    noContent: 'text-sm font-normal text-textSupporting',
    checkboxRow: 'flex-row',
  },
})();

const Checkbox: React.FC<{ isChecked: boolean }> = ({ isChecked }) => (
  <Svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    style={tw(styles.checkboxSvg())}
  >
    {/* Checkbox border */}
    <Path d="M1 1h10v10H1z" stroke="#383838" strokeWidth={1} fill="none" />
    {/* Checkmark */}
    {isChecked && (
      <Path
        d="M3 6l2 2 4-4"
        stroke="#383838"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    )}
  </Svg>
);

export const PdfCheckboxField: React.FC<{
  block: Block;
  amendments: PdfAmendment[];
  isInsideGroup?: boolean;
}> = ({ block, amendments, isInsideGroup = false }) => {
  if (block.type !== 'checkbox') return null;
  return (
    <View key={block.key}>
      {block.label && (
        <Text
          style={tw(
            isInsideGroup
              ? commonStyles.secondaryHeading()
              : commonStyles.primaryHeading(),
          )}
        >
          {block.label}
        </Text>
      )}
      <View style={tw(commonStyles.content())}>
        {block.options && block.options.length > 0 ? (
          block.options.map((option, index) => (
            <View key={index} style={tw(styles.checkboxRow())}>
              <Checkbox isChecked={option.isChecked} />
              <Text style={tw(commonStyles.body())}>{option.label}</Text>
            </View>
          ))
        ) : (
          <Text style={tw(styles.noContent())}>No options</Text>
        )}
        <TextAmendments blockPath={block.key} amendments={amendments} />
      </View>
    </View>
  );
};
